import NotificationTemplateSettings from '@/orm/models/Company/NotificationTemplate/NotificationTemplateSettings';
import { computed } from '@vue/composition-api';

export default function useNotificationTemplateSettings() {
  const notificationTemplatesSettings = computed(() => {
    return NotificationTemplateSettings.query().withAllRecursive().get();
  });

  async function getNotificationTemplatesSettings() {
    await NotificationTemplateSettings.api().fetchNotificationTemplatesSettings();
  }

  async function setNotificationTemplateSettings(payload) {
    await NotificationTemplateSettings.api().setNotificationTemplateSettings(payload);
  }

  return {
    notificationTemplatesSettings,
    getNotificationTemplatesSettings,
    setNotificationTemplateSettings,
  };
}
